import classnames from "classnames";
import PropTypes from "prop-types";
import { useMemo } from "react";

import Button from "../../Button";
import Icon from "../../Icon";
import Tooltip from "../../Tooltip";

const CardHeader = ({
  id,
  title,
  headerIcon,
  headerNumber,
  subtitle,
  headerCTA,
  collapseText,
  showAsterisk,
  description,
  collapsible,
  isExpanded,
  errorCount,
  tooltip,
  disabled,
  handleClick,
  setIsUserProposals,
  isUserProposals,
  proposalCounts,
  isCardWithTable,
  isCardLocked,
}) => {
  const collapseLabel = isExpanded ? "Collapse" : "Expand";

  const headerIconPath = useMemo(() => {
    if (headerIcon) {
      return require(`../../../assets/icons/${headerIcon}.svg`);
    }
    return null;
  }, [headerIcon]);

  return (
    <div className="card__header">
      <div className="card__header-title">
        {!isCardWithTable && (
          <h2 className="title">
            {headerIcon && <img src={headerIconPath} alt="headerIcon" />}
            {headerNumber && (
              <div
                className={classnames("card__header__number", {
                  "is-locked": isCardLocked,
                })}
              >
                <span>{headerNumber}</span>
              </div>
            )}
            {title}
            {isCardLocked && (
              <Icon
                name="lock-solid"
                size="small"
                className="icon--lock-card"
              />
            )}
            {!isExpanded && errorCount > 0 && (
              <span className="tab__item-error-count">{errorCount}</span>
            )}
          </h2>
        )}
        {description && <div className="description">{description}</div>}
        {tooltip && !disabled && <Tooltip {...tooltip} />}
      </div>
      <div className="card__header-control">
        {headerCTA}
        {subtitle && (
          <div>
            {showAsterisk && <span className="card__header-asterisk">*</span>}
            <span className="card__header-subtitle">{subtitle}</span>
          </div>
        )}
        {!disabled && collapsible && (
          <Button
            type="button"
            id={`${id}-header`}
            variant={collapseText ? "link" : "outline"}
            size="small"
            iconName={!isExpanded ? "system-open-down" : "system-open-up"}
            iconSize="extra-extra-small"
            iconPosition="right"
            disabled={disabled}
            onClick={handleClick}
            aria-controls={`${id}-panel`}
            aria-expanded={isExpanded}
            aria-label={collapseLabel}
            className="card__collapse-button"
          >
            {collapseText && collapseLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

CardHeader.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  headerIcon: PropTypes.string,
  headerNumber: PropTypes.string,
  subtitle: PropTypes.string,
  headerCTA: PropTypes.node,
  collapseText: PropTypes.bool,
  showAsterisk: PropTypes.bool,
  description: PropTypes.string,
  collapsible: PropTypes.bool,
  isExpanded: PropTypes.bool,
  errorCount: PropTypes.number,
  toolTip: PropTypes.object,
  disabled: PropTypes.bool,
  handleClick: PropTypes.func,
  setIsUserProposals: PropTypes.func,
  isUserProposals: PropTypes.bool,
  proposalCounts: PropTypes.object,
  isCardWithTable: PropTypes.bool,
  isCardLocked: PropTypes.bool,
};

CardHeader.defaultProps = {
  showAsterisk: true,
};

export default CardHeader;
